<!-- Filter - Search - Form  -->
<div *ngIf="userPermissions?.main_job_list?.view" class="data-action-form">
  <div class="row justify-content-between align-items-end">
    <div class="col-12 col-sm-12 col-md-12 col-lg-7 col-xl-8">
      <div class="row mx-n2 align-items-end">
        <div class="col-12 col-sm-6 col-md col-lg-4 col-xl px-2">
          <div class="form-group">
            <label>Project Manager</label>
            <select
              class="form-control select2"
              #projectManager
              id="project_manager_id"
              [(ngModel)]="searchInfo.project_manager_id"
              [ngModelOptions]="{ standalone: true }"
              (change)="searchInTable(projectManager.value, 'project_manager_id')">
              <option selected="selected" value="">Project Manager</option>
              <option *ngFor="let item of projectManagerData" value="{{ item.id }}">
                {{
                  item.employee_alias != null && item.employee_alias != '' && item.employee_alias != undefined
                    ? item.employee_alias
                    : item.first_name + ' ' + item.last_name
                }}
              </option>
            </select>
            <div style="width: 0 !important; height: 0 !important; overflow: hidden !important">
              <input
                type="text"
                [(ngModel)]="searchInfo.project_manager_id"
                [ngModelOptions]="{ standalone: true }"
                (blur)="searchInTable(projectManager.value, 'project_manager_id')" />
            </div>
          </div>
        </div>
        <div class="col-12 col-sm-6 col-md col-lg-4 col-xl px-2">
          <div class="form-group">
            <label>Assistant</label>
            <select
              class="form-control select2"
              #projectAssistant
              id="assistant_id"
              [(ngModel)]="searchInfo.assistant_id"
              [ngModelOptions]="{ standalone: true }"
              (change)="searchInTable(projectAssistant.value, 'assistant_id')">
              <option selected="selected" value="">Assistant</option>
              <option *ngFor="let item of ProjectAssistantData" value="{{ item.id }}">
                {{ item.name }}
              </option>
            </select>
            <div style="width: 0 !important; height: 0 !important; overflow: hidden !important">
              <input
                type="text"
                [(ngModel)]="searchInfo.assistant_id"
                [ngModelOptions]="{ standalone: true }"
                (blur)="searchInTable(projectAssistant.value, 'assistant_id')" />
            </div>
          </div>
        </div>
        <div class="col-12 col-sm-6 col-md col-lg-4 col-xl px-2">
          <div class="form-group">
            <label>Foreman</label>
            <select
              class="form-control select2"
              #jobForeman
              id="foreman_id"
              [(ngModel)]="searchInfo.foreman_id"
              [ngModelOptions]="{ standalone: true }"
              (change)="searchInTable(jobForeman.value, 'foreman_id')">
              <option selected="" value="">Foreman</option>
              <option *ngFor="let item of projectForemanData" value="{{ item.id }}">
                {{ item.name }}
              </option>
            </select>
            <div style="width: 0 !important; height: 0 !important; overflow: hidden !important">
              <input
                type="text"
                [(ngModel)]="searchInfo.foreman_id"
                [ngModelOptions]="{ standalone: true }"
                (blur)="searchInTable(jobForeman.value, 'foreman_id')" />
            </div>
          </div>
        </div>
        <div class="col-12 col-sm-6 col-md col-lg-8 col-xl px-2">
          <div class="form-group">
            <label>Job Status</label>
            <select
              class="form-control select2MultipleWithCheck"
              id="status"
              name="status"
              data-placeholder="Job Status"
              multiple="multiple">
              <option value="1" [selected]="checkIsSelected('1', 'status')">Started</option>
              <option value="2,3,4" [selected]="checkIsSelected('2,3,4', 'status')">Active</option>
              <option value="5" [selected]="checkIsSelected('5', 'status')">Closed</option>
              <option value="0" [selected]="checkIsSelected('0', 'status')">Deleted</option>
            </select>
            <div style="width: 0 !important; height: 0 !important; overflow: hidden !important">
              <input
                type="text"
                [(ngModel)]="searchInfo.status"
                class="multiCheckVal"
                #jobStatus
                (blur)="searchInTable(jobStatus.value, 'status')" />
            </div>
          </div>
        </div>
        <div class="col-12 col-sm-12 col-md col-lg-4 col-xl px-2">
          <div class="form-group">
            <a href="javascript:;" data-toggle="modal" data-target="#filter" class="btn btn-outline-primary more-filter"
              >More Filters <span class="dot">.</span> 5</a
            >
          </div>
        </div>
      </div>
    </div>
    <div class="col-12 col-sm-12 col-md-12 col-lg-5 col-xl-3">
      <div class="row mx-n2 align-items-end">
        <div class="col-5 col-sm-5 col-md-5 col-lg-5 px-2">
          <div class="search-box">
            <div class="form-group">
              <input
                type="text"
                name=""
                placeholder="Search"
                [(ngModel)]="searchInfo.search"
                [ngModelOptions]="{ standalone: true }"
                class="form-control fild"
                #search
                id="search" />
              <div style="width: 0 !important; height: 0 !important; overflow: hidden !important">
                <input type="text" id="searchData" (blur)="searchInTable(search.value, 'search')" />
              </div>
              <a href="javascript:;" class="search"><i class="fas fa-search"></i></a>
            </div>
          </div>
        </div>
        <div class="col-3 col-sm-3 col-md-3 col-lg-3 px-1" *ngIf="userPermissions?.main_job_list?.edit">
          <div class="form-group">
            <a href="javascript:;" class="btn btn-block btn-primary" (click)="generateCSV(); (false)"> Export </a>
          </div>
        </div>
        <div class="col-4 col-sm-4 col-md-4 col-lg-4 px-1" *ngIf="userPermissions?.main_job_list?.edit">
          <div class="form-group">
            <a
              href="javascript:;"
              data-toggle="modal"
              data-target="#create-job"
              #createNewJob
              class="btn btn-block btn-primary"
              (click)="setLoadFocus()"
              >+ New Job</a
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Filter - Search - Form  End-->
<div *ngIf="userPermissions?.main_job_list?.view" class="filter-options filter-options-row">
  <ul class="list-unstyled d-flex">
    <li><a href="javascript:;" (click)="saveFilter()">Save Filters</a></li>
    <li class="divider">|</li>
    <li><a href="javascript:;" (click)="clearFilter()">Clear Filters</a></li>
  </ul>
  <p id="active-jobs-text">Active Jobs: {{ activeJobCount }}</p>
</div>
<div *ngIf="userPermissions?.main_job_list?.view" class="data-table-scroll-container">
  <div class="table-responsive">
    <table class="table jobs-data-table data-table-scroll">
      <thead>
        <tr>
          <th id="name" (click)="sortTable('j.name', $event)">Project Name</th>
          <th id="number" (click)="sortTable('j.number', $event)">Job #</th>
          <th id="departments_list" (click)="sortTable('departments_list', $event)">Department(s)</th>
          <th id="owner_name" (click)="sortTable('o.owner_name', $event)">Owner</th>
          <th id="facility_name" (click)="sortTable('f.facility_name', $event)">Facility / Location</th>
          <th id="created_date" (click)="sortTable('j.created_date', $event)">Job Creation Date</th>
          <th id="project_manager_name" (click)="sortTable('project_manager_name', $event)">Project Manager</th>
          <th id="project_assistant_name" (click)="sortTable('project_assistant_name', $event)">Assistant</th>
          <th id="project_foreman_name" (click)="sortTable('project_foreman_name', $event)">Foreman</th>
          <th id="contact_tm" (click)="sortTable('j.contact_tm', $event)" id="sort_t_m">T&M</th>
          <th id="status" (click)="sortTable('j.status', $event)">Status</th>
          <th id="submit_to_accounting" (click)="sortTable('j.submit_to_accounting', $event)">STA</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of jobsData">
          <td>
            <a [routerLink]="[item.id]" class="text-blue">{{ item.name }}</a>
          </td>
          <td>{{ item.number }}</td>
          <td width="10%">
            <a
              href="javascript:;"
              class="text-blue"
              data-toggle="modal"
              data-target="#department"
              (click)="getJobDepartmentData(item.id)"
              >{{ item.department_codes }}</a
            >
          </td>
          <td>{{ item.owner_name }}</td>
          <td>{{ item.facility_name }}</td>
          <td>{{ getLocalTime(item.created_date) }}</td>
          <td>{{ item.project_manager_name }}</td>
          <td>{{ item.project_assistant_name }}</td>
          <td>{{ item.project_foreman_name }}</td>
          <td class="data_order" id="{{ item.contact_tm }}">
            <span style="display: none">{{ item.contact_tm }}</span
            ><span class="status-icon" *ngIf="item.contact_tm">
              <i class="far fa-check"></i>
            </span>
          </td>
          <td>
            <span class="btn btn-info btn-icon d-flex justify-content-between" *ngIf="item.status == 1"
              >Started
              <i
                class="fas fa-info-circle"
                data-toggle="tooltip"
                data-html="true"
                title="{{ item.number }} Issued. Sage setup pending."></i
            ></span>
            <span
              class="btn btn-success btn-icon d-flex justify-content-between"
              *ngIf="item.status == 2 || item.status == 3 || item.status == 4"
              >Active
              <i
                class="fas fa-info-circle"
                data-toggle="tooltip"
                data-html="true"
                data-original-title="Job is active in Sage"></i
            ></span>
            <span class="btn btn-dark-100 btn-icon d-flex justify-content-between" *ngIf="item.status == 5"
              >Closed
              <i
                class="fas fa-info-circle"
                data-toggle="tooltip"
                data-html="true"
                data-original-title="Job is closed in Sage"></i
            ></span>
            <span class="btn btn-danger btn-icon d-flex justify-content-between" *ngIf="item.status == 0"
              >Deleted
              <i
                class="fas fa-info-circle"
                data-toggle="tooltip"
                data-html="true"
                data-original-title="Job setup cancelled"></i
            ></span>
          </td>
          <td>
            <span style="display: none">{{item.submit_to_accounting}</span
            ><span class="status-icon" *ngIf="item.submit_to_accounting">
              <i class="far fa-check"></i>
            </span>
          </td>
          <td>
            <a
              href="#"
              class="action-dropdown"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
              *ngIf="item.status == 1 && item.is_deleted == 0"
              ><i class="fas fa-ellipsis-v"></i
            ></a>
            <div class="dropdown-menu">
              <a
                class="dropdown-item"
                href="javascript:;"
                data-toggle="modal"
                data-target="#delete-job"
                (click)="setDeleteJobId(item.id)"
                *ngIf="userPermissions?.main_job_list?.edit"
                >Delete Job</a
              >
              <span class="dropdown-item disabled" *ngIf="!userPermissions?.main_job_list?.edit">Delete Job</span>
            </div>
          </td>
        </tr>
      </tbody>
    </table>

    <div class="pagination" *ngIf="jobsData">
      <span
        [ngClass]="{ disabled: curPage == 1, paginate_button: true }"
        (click)="changeCurrentPage('first')"
        *ngIf="numberOfPages() > 5"
        >FIRST</span
      >
      <span
        [ngClass]="{ disabled: curPage == 1, paginate_button: true }"
        (click)="changeCurrentPage('prev')"
        *ngIf="numberOfPages() > 1"
        >PREV</span
      >
      <span
        *ngFor="let page of pages"
        (click)="changeCurrentPage(page)"
        [ngClass]="{ paginate_button: page != -1, active_page: page == curPage, disabled: page == curPage }"
        >{{ page }}</span
      >
      <span
        [ngClass]="{ disabled: numberOfPages() == curPage, paginate_button: true }"
        (click)="changeCurrentPage('next')"
        *ngIf="numberOfPages() > 1"
        >NEXT</span
      >
      <span
        [ngClass]="{ disabled: numberOfPages() == curPage, paginate_button: true }"
        (click)="changeCurrentPage('last')"
        *ngIf="numberOfPages() > 5"
        >LAST</span
      >
    </div>
  </div>
</div>

<!-- Filter Modal -->
<div class="modal fade" id="filter" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content pb-0">
      <form action="#" id="FiltersForm">
        <div class="modal-header">
          <h5 class="modal-title">More Filters</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true"><i class="fal fa-times"></i></span>
          </button>
        </div>
        <div class="modal-body">
          <div class="form-group">
            <label>Department</label>
            <select
              class="form-control select2MultipleWithCheck"
              id="department_codes"
              name="department_codes"
              data-placeholder="Department"
              multiple="multiple">
              <option
                *ngFor="let item of departmentsData"
                value="{{ item.department_short_code }}"
                [selected]="checkIsSelected(item.department_short_code, 'department_codes')">
                {{ item.department_short_code + ' | ' + item.department_name }}
              </option>
            </select>
            <div style="width: 0 !important; height: 0 !important; overflow: hidden !important">
              <input
                type="text"
                [(ngModel)]="searchInfo.department_codes"
                class="multiCheckVal"
                #deptCodes
                (blur)="searchInTable(deptCodes.value, 'department_codes')"
                name="dept_codes" />
            </div>
          </div>
          <div class="form-group">
            <label>Owner</label>
            <select
              class="form-control select2"
              #projectOwner
              id="owner_id"
              [(ngModel)]="searchInfo.owner_id"
              name="owner_id">
              <option selected="" value="">Owner</option>
              <option *ngFor="let item of ownersData" value="{{ item.id }}">{{ item.owner_name }}</option>
            </select>
            <div style="width: 0 !important; height: 0 !important; overflow: hidden !important">
              <input
                type="text"
                [(ngModel)]="searchInfo.owner_id"
                [ngModelOptions]="{ standalone: true }"
                (blur)="searchInTable(projectOwner.value, 'owner_id')" />
            </div>
          </div>
          <div class="form-group">
            <label>Year</label>
            <select class="form-control select2" #projectYear id="year" [(ngModel)]="searchInfo.year" name="year">
              <option selected="" value="">Year</option>
              <option *ngFor="let item of yearFilterData" value="{{ item.year }}">20{{ item.year }}</option>
            </select>
            <div style="width: 0 !important; height: 0 !important; overflow: hidden !important">
              <input
                type="text"
                [(ngModel)]="searchInfo.year"
                [ngModelOptions]="{ standalone: true }"
                (blur)="searchInTable(projectYear.value, 'year')" />
            </div>
          </div>
          <div class="form-group">
            <label>PreCon</label>
            <select
              class="form-control select2"
              #projectPreCon
              id="is_precon_involved"
              [(ngModel)]="searchInfo.is_precon_involved"
              name="is_precon_involved">
              <option value="">PreCon</option>
              <option value="1">Yes</option>
              <option value="0">No</option>
            </select>
            <div style="width: 0 !important; height: 0 !important; overflow: hidden !important">
              <input
                type="text"
                [(ngModel)]="searchInfo.is_precon_involved"
                [ngModelOptions]="{ standalone: true }"
                (blur)="searchInTable(projectPreCon.value, 'is_precon_involved')" />
            </div>
          </div>
          <div class="form-group">
            <label>Submit To Accounting</label>
            <select
              class="form-control select2"
              #submit_to_accounting
              id="submit_to_accounting"
              [(ngModel)]="searchInfo.submit_to_accounting"
              name="submit_to_accounting">
              <option value="">Submit To Accounting</option>
              <option value="1">Yes</option>
              <option value="0">No</option>
            </select>
            <div style="width: 0 !important; height: 0 !important; overflow: hidden !important">
              <input
                type="text"
                [(ngModel)]="searchInfo.submit_to_accounting"
                [ngModelOptions]="{ standalone: true }"
                (blur)="searchInTable(submit_to_accounting.value, 'submit_to_accounting')" />
            </div>
          </div>
        </div>
        <div class="modal-footer justify-content-center border-0">
          <button type="button" class="btn btn-outline-primary width-fix" #closeFilterModel data-dismiss="modal">
            Close
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
<!-- Filter Modal End-->

<!-- Create New Job Modal -->
<div class="modal fade" id="create-job" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog modal-lg">
    <div class="modal-content pb-0">
      <form [formGroup]="addJobForm" *ngIf="addJobForm" id="myJobForm" (ngSubmit)="onNewJobSubmit(addJobForm)">
        <div class="modal-header bg-color">
          <h5 class="modal-title">Create New Job</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true"><i class="fal fa-times"></i></span>
          </button>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-12 col-sm-12 col-md-12 col-lg-12">
              <div class="form-group">
                <label>Project Name * (Max 30 character limit)</label>
                <input
                  type="text"
                  class="form-control"
                  placeholder="Project Name"
                  formControlName="name"
                  tabindex="1"
                  maxlength="30"
                  #name
                  id="name"
                  (input)="setDataToControl('name', name.value)" />
                <span
                  class="error"
                  *ngIf="addJobForm.get('name').hasError('required') && addJobForm.get('name').touched">
                  Please provide name
                </span>
              </div>
            </div>
            <div class="col-12 col-sm-12 col-md-6 col-lg-6">
              <div class="form-group">
                <label>Main Project Manager *</label>
                <select
                  class="form-control select2"
                  formControlName="project_manager_id"
                  #project_manager_id
                  tabindex="2">
                  <option selected="" value="">Main Project Manager</option>
                  <option *ngFor="let item of projectManagerData" value="{{ item.id }}">
                    {{
                      item.employee_alias != null && item.employee_alias != '' && item.employee_alias != undefined
                        ? item.employee_alias
                        : item.first_name + ' ' + item.last_name
                    }}
                  </option>
                </select>
                <div style="width: 0 !important; height: 0 !important; overflow: hidden !important">
                  <input
                    type="text"
                    formControlName="project_manager_id"
                    id="project_manager_id"
                    (blur)="setDataToControl('project_manager_id', project_manager_id.value)" />
                </div>
                <span
                  class="error"
                  *ngIf="
                    addJobForm.get('project_manager_id').hasError('required') &&
                    addJobForm.get('project_manager_id').touched
                  ">
                  Please select project manager
                </span>
              </div>
            </div>
            <div class="col-12 col-sm-12 col-md-6 col-lg-6">
              <div class="form-group">
                <label>Main Assistant *</label>
                <select class="form-control select2" formControlName="assistant_id" #assistant_id tabindex="3">
                  <option selected="" value="">Main Assistant</option>
                  <option *ngFor="let item of ProjectAssistantData" value="{{ item.id }}">
                    {{ item.name }}
                  </option>
                </select>
                <div style="width: 0 !important; height: 0 !important; overflow: hidden !important">
                  <input
                    type="text"
                    formControlName="assistant_id"
                    id="assistant_id"
                    (blur)="setDataToControl('assistant_id', assistant_id.value)" />
                </div>
                <span
                  class="error"
                  *ngIf="addJobForm.get('assistant_id').hasError('required') && addJobForm.get('assistant_id').touched">
                  Please select project assistant
                </span>
              </div>
            </div>
          </div>
          <div class="card">
            <div class="card-header d-flex justify-content-between align-items-center">
              <span class="font-weight-bold">Departments on Job *</span>
              <a href="javascript:;" class="font-italic">Select all that apply</a>
            </div>
            <div class="card-body">
              <div class="row row-cols-1 row-cols-sm-2 row-cols-md-3 row-cols-lg-4">
                <div class="col" *ngFor="let item of departmentsData; let i = index">
                  <div class="custom-control custom-checkbox mb-2">
                    <input
                      class="custom-control-input"
                      type="checkbox"
                      id="inlineCheckbox{{ item.id }}"
                      value="{{ i == 0 ? 1 : 0 }}"
                      name="{{ i }}"
                      (click)="storeSubDepartments($event, item.id)"
                      tabindex="{{ 4 + i }}" />
                    <label class="custom-control-label" for="inlineCheckbox{{ item.id }}">
                      {{ item.department_short_code }} - {{ item.department_name }}</label
                    >
                  </div>
                </div>
              </div>
              <span
                class="error"
                *ngIf="
                  addJobForm.get('sub_department_number').hasError('required') &&
                  addJobForm.get('sub_department_number').touched
                ">
                Please select department
              </span>
              <div class="row mt-3">
                <div class="col-12 col-sm-12 col-md-6 col-lg-6">
                  <div class="form-group">
                    <label>Select Main Job *</label>
                    <select
                      class="form-control select2"
                      id="mainDepartmentSelect"
                      formControlName="main_job"
                      #mainDepartment
                      (change)="setSubDepartments($event, mainDepartment.value)"
                      tabindex="130">
                      <option value="">Main Job</option>
                      <option *ngFor="let item of departmentsData; let i = index" value="{{ item.id }}">
                        {{ item.department_short_code }} - {{ item.department_name }}
                      </option>
                    </select>
                    <div style="width: 0 !important; height: 0 !important; overflow: hidden !important">
                      <input
                        type="text"
                        formControlName="main_job"
                        id="mainDepartment"
                        (blur)="setSubDepartments($event, mainDepartment.value)" />
                    </div>
                    <span
                      class="error"
                      *ngIf="addJobForm.get('main_job').hasError('required') && addJobForm.get('main_job').touched">
                      Please select main job
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="card mt-4">
            <div class="card-header d-flex justify-content-between align-items-center">
              <span class="font-weight-bold">Contract Size</span>
            </div>
            <div class="card-body">
              <div class="custom-control custom-radio mb-2">
                <input
                  class="custom-control-input"
                  type="radio"
                  name="contract_size"
                  id="exampleRadios1"
                  value="1"
                  checked
                  formControlName="contract_size" />
                <label class="custom-control-label" for="exampleRadios1">$0 - $10,000</label>
              </div>
              <div class="custom-control custom-radio mb-2">
                <input
                  class="custom-control-input"
                  type="radio"
                  name="contract_size"
                  id="exampleRadios2"
                  value="2"
                  formControlName="contract_size" />
                <label class="custom-control-label" for="exampleRadios2">$10,000 - $100,000</label>
              </div>
              <div class="custom-control custom-radio mb-2">
                <input
                  class="custom-control-input"
                  type="radio"
                  name="contract_size"
                  id="exampleRadios3"
                  value="3"
                  formControlName="contract_size" />
                <label class="custom-control-label" for="exampleRadios3">$100,000 or Greater</label>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer justify-content-center border-0">
          <button
            type="button"
            class="btn btn-outline-primary width-fix"
            #closebutton
            data-dismiss="modal"
            tabindex="131">
            Cancel
          </button>
          <a href="javascript:;" (click)="onNewJobSubmit(addJobForm)" class="btn btn-primary width-fix" tabindex="132"
            >Save and Close</a
          >
          <a
            href="javascript:;"
            (click)="onNewJobSubmit(addJobForm, 'true')"
            class="btn btn-primary width-fix"
            tabindex="133"
            >Continue</a
          >
        </div>
      </form>
    </div>
  </div>
</div>
<!-- Create New Job Modal End-->

<!-- Department Modal -->
<div class="modal fade" id="department" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog modal-lg">
    <div class="modal-content pb-0" *ngIf="jobDetail">
      <div class="modal-header">
        <h5 class="modal-title">{{ jobDetail[0].name }} - {{ jobDetail[0].number }}</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true"><i class="fal fa-times"></i></span>
        </button>
      </div>
      <div class="modal-body p-0">
        <div class="table-responsive">
          <table class="table mb-0">
            <thead>
              <tr>
                <th>Department</th>
                <th>Project Manager</th>
                <th>Project Assistant</th>
                <th>Foreman</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of jobDetail">
                <td>
                  <strong>{{ item.department_short_code }} - {{ item.department_name }}</strong>
                  <!-- <strong *ngIf="item.is_main_job">Main Job: {{item.department_short_code}} - {{item.department_name}}</strong> -->
                  <!-- <strong *ngIf="!item.is_main_job">Sub Job: {{item.department_short_code}} - {{item.department_name}}</strong> -->
                </td>
                <td>{{ item.project_manager_name }}</td>
                <td>{{ item.project_assistant_name }}</td>
                <td>
                  <ng-container *ngIf="item.project_foreman_name === null && item.foreman_id === 0">TBD</ng-container>
                  <ng-container *ngIf="item.project_foreman_name === null && item.foreman_id === 999999999"
                    >No Foreman</ng-container
                  >
                  <ng-container
                    *ngIf="item.project_foreman_name !== null && item.foreman_id !== 0 && item.foreman_id !== 999999999"
                    >{{ item.project_foreman_name }}</ng-container
                  >
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- Department Modal End-->

<!-- Delete Job Modal -->
<div class="modal fade" id="delete-job" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog modal-lg">
    <div class="modal-content pb-0">
      <form action="#">
        <div class="modal-header border-0">
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true"><i class="fal fa-times"></i></span>
          </button>
        </div>
        <div class="modal-body pb-0 pt-0">
          <div class="notification-text text-center">
            <h4 class="font-weight-normal">
              Are you sure you would like to delete this job? <br />
              All the content and details will be lost.
            </h4>
          </div>
        </div>
        <div class="modal-footer justify-content-center border-0">
          <button type="button" class="btn btn-outline-primary width-fix" #closebutton1 data-dismiss="modal">
            Cancel
          </button>
          <button type="submit" class="btn btn-primary width-fix" (click)="deleteJob(deleteJobId)">Delete Job</button>
        </div>
      </form>
    </div>
  </div>
</div>

<!-- Delete Job Modal End-->
<a href="javascript:;" data-toggle="modal" data-target="#new-job-id" #new_job_id></a>

<!-- New Job Id Modal -->
<div class="modal fade" id="new-job-id" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content pb-0">
      <form action="#">
        <div class="modal-header border-0">
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true"><i class="fal fa-times"></i></span>
          </button>
        </div>
        <div class="modal-body pb-0 pt-0">
          <div class="notification-text text-center">
            <h4 class="font-weight-normal">The Job# number generated for this submission is:</h4>
            <h4>
              {{ new_job_name }}
            </h4>
            <!-- <h4 *ngFor="let item of newAddedDepartments">
                            {{new_job_number}}-{{item}}
                        </h4> -->
            <h4 *ngIf="new_job_number">{{ new_job_number }}-{{ newAddedDepartments }}</h4>
          </div>
        </div>
        <div class="modal-footer justify-content-center border-0">
          <button type="button" class="btn btn-outline-primary width-fix" #closebutton2 data-dismiss="modal">
            Close
          </button>
          <button type="button" class="btn btn-primary width-fix" (click)="openCreateNewJobModel()">
            Create New Job
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
<!-- New Job Id Modal End-->
